module.exports = __webpack_public_path__ + "img/gp.93618552.png";